import { SupplierWarehouseProps } from '@/types'

export const addressLine = (address: SupplierWarehouseProps): string => {
  const baseAddress = `${address?.street}, ${address?.number}`
  const postalReference = `${address?.postalCode}, ${address?.neighborhood}`
  const location = `${address?.city}, ${address?.state}`

  if (address?.complement) {
    return `${baseAddress}, ${address?.complement}, ${postalReference} - ${location}`
  } else {
    return `${baseAddress}, ${postalReference} - ${location}`
  }
}
